import { CreditCardUtilitiesServiceModule } from 'services/utilities/creditCardUtilities.service';
import template from './creditCardEditor.html';
import './creditCard.scss';

export const CreditCardEditorModule = angular
    .module('app.components.creditCards.creditCardEditor', [
        CreditCardUtilitiesServiceModule
    ]).directive('creditCardEditor', (
        creditCardUtilities
    ) => {
        return {
            restrict: 'EA',
            scope: {
                card: '=',
                creditCardForm: '=formController',
                onChange: '&'
            },
            template,
            controller: ($scope) => {
                var vm = {
                    ccClass: 'credit-card-img--unknown',
                    setCardInfo
                };

                init();

                function init() {
                    $scope.vm = vm;
                    vm.setCardInfo();
                }

                function setCardInfo(cardType) {
                    vm.ccClass = creditCardUtilities.getCssClass(cardType);
                    if ($scope.creditCardForm &&
                        $scope.creditCardForm.cardNumber &&
                        $scope.creditCardForm.cardNumber.$ccEagerType) {
                        $scope.card = $scope.card || {};
                        $scope.card.cardTypeName = $scope.creditCardForm.cardNumber.$ccEagerType;
                        if ($scope.onChange) $scope.onChange({ card: $scope.card });
                    }
                }
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/creditCards/creditCardEditor/creditCardEditor.module.js